import axiosInstance from "./AxiosInstance";
import config from "../config";

const { apiAppendPath } = config;

export const searchMedications = (searchString) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/medications`, {
        params: { name: searchString },
    });
}

export const getMedicationByNameAndStrength = (name, strength) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/medications/medication`, {
        params: { name, strength },
    });
}

export const getMedicationByDispensableDrugId = (dispensableDrugId) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/medications/${dispensableDrugId}`);
}

export const getAllAvailableDispenseUnits = () => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/medications/dispense-units`);
}

export const searchSupplies = (params) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/supplies`, { params });
}

export const getSupplyById = (supplyId) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/supplies/${supplyId}`);
}

export const getPatientPrescriptionHistory = (patientId, options = {}) => {
    const queryParams = new URLSearchParams({ source: 'front-end' });
    
    // Add optional parameters if provided
    if (options.startDate) {
        queryParams.append('startDate', options.startDate);
    }
    if (options.endDate) {
        queryParams.append('endDate', options.endDate);
    }
    
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/patient/${patientId}?${queryParams.toString()}`);
}

export const updatePatient = (patientId, update) => {
    return axiosInstance.put(`${apiAppendPath.prescriptionsAppendPath}/patient/${patientId}`, {
        data: update,
    });
}

export const updatePatientDefaultPharmacy = (patientId, pharmacyId) => {
    return axiosInstance.put(`${apiAppendPath.prescriptionsAppendPath}/patient/${patientId}/default-pharmacy`, {
        data: { pharmacyId }
    });
}

export const getRxErrors = () => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/rx-errors`);
}

export const acknowledgeError = errorId => {
    return axiosInstance.put(`${apiAppendPath.prescriptionsAppendPath}/rx-errors/${errorId}`);
}

export const requeueErrorPrescription = prescriptionId => {
    return axiosInstance.put(`${apiAppendPath.prescriptionsAppendPath}/${prescriptionId}`);
}

export const rollBackCase = (caseId, errorId, providerId) => {
    return axiosInstance.put(`${apiAppendPath.prescriptionsAppendPath}/rx-errors/rollback/${caseId}`, {
        data: { caseId, errorId, providerId },
    });
}

export const cancelPrescription = (prescriptionId, providerId) => {
    return axiosInstance.post(`${apiAppendPath.prescriptionsAppendPath}/${prescriptionId}/cancel`, {
        ...(providerId && { providerId })
    });
}

export const getPharmacybyId = (pharmacyId) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/pharmacy/${pharmacyId}`);
}

export const getPatientAllergies = (patientId) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/patient/${patientId}/allergies`);
}

export const searchAllergies = (query) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/allergies`, {
        params: { q: query }
    });
}

export const searchPharmacies = (params, signal) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/pharmacy`, {
        params,
        signal
    });
}

export const resendPrescription = ({ prescriptionId, providerId }) => {
    return axiosInstance.put(`${apiAppendPath.prescriptionsAppendPath}/${prescriptionId}`,
        ...(providerId && { providerId })
    );
}

export const deletePrescription = (prescriptionId, providerId) => {
    return axiosInstance.delete(`${apiAppendPath.prescriptionsAppendPath}/${prescriptionId}`, {
        ...(providerId && { providerId })
    });
}

